document.addEventListener("DOMContentLoaded", function() {
  const DEBUG = true;
  const log = (...args) => DEBUG && console.log("[DEPOSIT]", ...args);

  // ✅ Deposit variant ID (your "Zálohový poplatok 0,15€")
  const depositVariantId = 54483613679884;

  async function getCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    return res.json();
  }

  function calculateDepositCount(cart) {
    let depositCount = 0;

    document.querySelectorAll('.m-cart-drawer-item').forEach(el => {
      const variantId = parseInt(el.dataset.variantId, 10);

      // ✅ Only count products with vratna_zaloha = true AND not the deposit product itself
      if (el.dataset.vratnaZaloha === "true" && variantId !== depositVariantId) {
        const item = cart.items.find(i => i.variant_id === variantId);
        if (item) {
          depositCount += item.quantity;
        }
      }
    });

    return depositCount;
  }

  async function syncDeposits() {
    const cart = await getCart();
    const depositCount = calculateDepositCount(cart);
    log("Needed depositCount:", depositCount);

    const depositItem = cart.items.find(i => i.variant_id === depositVariantId);
    const currentQty = depositItem ? depositItem.quantity : 0;

    if (depositCount !== currentQty) {
      log(`Syncing deposit → Current: ${currentQty}, Wanted: ${depositCount}`);

      if (depositCount === 0 && depositItem) {
        // ❌ Remove deposit
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: depositItem.key, quantity: 0 })
        });

      } else if (!depositItem && depositCount > 0) {
        // ➕ Add deposit
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: depositVariantId,
            quantity: depositCount
          })
        });

      } else if (depositItem && depositCount > 0) {
        // 🔄 Update deposit qty
        const updates = {};
        updates[depositVariantId] = depositCount;
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });
      }

      // Refresh cart drawer after update
      location.reload();
    } else {
      log("Deposit already correct.");
    }
  }

  // Run once on page load
  syncDeposits();

  // Re-sync when drawer changes
  document.addEventListener('change', (e) => {
    if (e.target.closest('.m-cart-drawer')) {
      setTimeout(syncDeposits, 600);
    }
  });

  document.addEventListener('submit', (e) => {
    if (e.target.closest('.m-cart-drawer')) {
      setTimeout(syncDeposits, 800);
    }
  });
});
